<button
    class="icon-badge"
    matBadge="check"
    matBadgeSize="small"
    (click)="openFilterDialog()"
    [matBadgeHidden]="!filterSettings.isFilterActive()"
    color="accent"
    mat-icon-button
>
    <mat-icon>filter_alt</mat-icon>
</button>
